import { useEffect, useReducer, useState } from 'react';
import { fetchReducer, FETCH_ACTION_TYPES, FetchState } from 'src/reducers/fetchReducer';
import { getDefinedReportURL, DefinedReportResponse } from 'src/api/interactiveReports';

const initialState: FetchState<any> = {
  loading: false,
  error: null,
  data: null,
};

const useDefinedReportFetch = (reprtName: string): [FetchState<any>, string | null] => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    let ignore = false;
    const fetch = async () => {
      dispatch({ type: FETCH_ACTION_TYPES.loading, payload: { loading: true } });
      try {
        const response: DefinedReportResponse = await getDefinedReportURL(reprtName);
        if (response.statusCode === 500) {
          setErrorMsg(response.statusMessage);
        } else if (!ignore) {
          dispatch({
            type: FETCH_ACTION_TYPES.setData,
            payload: { data: { enable_cloud_tableau: response.enable_cloud_tableau, reportURL: response.reportURL } },
          });
        }
      } catch (e: any) {
        if (!ignore) {
          dispatch({ type: FETCH_ACTION_TYPES.setError, payload: { error: e.message } });
          setErrorMsg(e.message);
        }
      }
    };
    fetch();
    return () => {
      ignore = true;
    };
  }, [reprtName]);

  return [state, errorMsg];
};

export default useDefinedReportFetch;
